// Common
import { callQBookingApi } from "./common";

// Utils
import { get, post, put, patch } from "Utils/HTTPMethods";

export const getPatientsByUserEmail = async (
  email,
  { isActiveOnly = true, hidden = true, includeGuests = false } = {}
) => {
  return callQBookingApi(get, "/patient", {
    email,
    isActiveOnly,
    hidden,
    includeGuests,
  });
};

export const getPatient = async (id) => {
  return callQBookingApi(get, "/patient", { id });
};

export const createPatient = async (patient) => {
  return callQBookingApi(post, "/patient", patient);
};

export const updatePatient = async (patient) => {
  return callQBookingApi(put, "/patient", patient);
};

export const deactivatePatient = async (id) => {
  return callQBookingApi(patch, "/patient", { id, isActive: false });
};
